import axios from 'axios'
import { api } from '../urlConfig'

const guestApiBaseUrl = process.env.REACT_APP_GUEST_API_BASE_URL ||
    (process.env.NODE_ENV === 'production' ? '/guest-api' : api)

const guestApi = axios.create({
    baseURL: guestApiBaseUrl,
})

guestApi.interceptors.request.use((config) => {
    const guestToken = String(config.sceneGuestToken || '').trim()

    config.headers = config.headers || {}

    delete config.headers.siteName
    delete config.headers.Authorization

    if (guestToken) {
        config.headers.Authorization = `Bearer ${guestToken}`
    }

    return config
})

export default guestApi